import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["elapsed"]
  static values = {
    prefix: { type: String, default: "" },
    suffix: { type: String, default: "초 경과" },
  }

  connect() {
    this.startedAt = performance.now()
    this.update()
    this.intervalId = window.setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (!this.intervalId) return

    window.clearInterval(this.intervalId)
    this.intervalId = null
  }

  update() {
    if (!this.hasElapsedTarget) return

    const seconds = Math.max(0, Math.floor((performance.now() - this.startedAt) / 1000))
    this.elapsedTarget.textContent = `${this.prefixValue}${seconds}${this.suffixValue}`
  }
}
